<template lang="pug">
  div
    div.p1.basic700--text {{ $t('select_local_delivery') }}
    v-radio-group(v-if="showRadio" v-model="localdeliveryService" row dense)
      v-row(no-gutters)
        v-col
          v-radio(value="motorcycle" color="info500")
            template(v-slot:label)
              div.p2.primary--text {{ $t('motorcycle') }}
        v-col
          v-radio(value="car" color="info500")
            template(v-slot:label)
              div.p2.primary--text {{ $t('car') }}
    template
      template(v-for="localDelivery in localDeliveries")
        div.px-2.py-4.my-2(:style="(selectedFulfilment && localDelivery.service_id === selectedFulfilment.service_id) ? activeBorder : inactiveBorder" @click="selectedFulfilment = localDelivery")
          v-row(no-gutters align="center")
            v-col.shrink
              div(style="width: 72px" align="center")
                v-img(:src="localDelivery.shipping_logo || require('@/assets/image_placeholder.png')" contain max-width="72" max-height="32")
            v-col.pl-2
              div.p2.basic700--text {{ localDelivery.shipping_name }}
              div.p2.basic700--text {{ localDelivery.service_type }}
</template>

<script>
export default {
  name: 'BulkSelectLocalDelivery',
  props: ['parentRates', 'parentSelectedFulfilment'],
  data: () => ({
    activeBorder: {
      border: '2px solid var(--v-info500)',
      borderRadius: '4px',
      backgroundColor: 'var(--v-infoT08)'
    },
    inactiveBorder: {
      border: '1px solid var(--v-basic400)',
      borderRadius: '4px',
    },
    disabledBorder: {
      borderRadius: '4px',
      backgroundColor: 'var(--v-basic300)',
      opacity: 0.5
    },
    motorcycleLocalDeliveries: null,
    carLocalDeliveries: null,
    localdeliveryService: null,
    showRadio: true,
  }),
  computed: {
    rates: {
      get () {
        return this.parentRates
      },
      set (newValue) {
        this.$emit('update:parentRates', newValue)
      }
    },
    selectedFulfilment: {
      get () {
        return this.parentSelectedFulfilment
      },
      set (newValue) {
        this.$emit('update:parentSelectedFulfilment', newValue)
      }
    },
    localDeliveries () {
      if (this.localdeliveryService === 'motorcycle') {
        return this.motorcycleLocalDeliveries
      } else if (this.localdeliveryService === 'car') {
        return this.carLocalDeliveries
      } else {
        return []
      }
    }
  },
  watch: {
    rates: {
      deep: true,
      immediate: true,
      handler (val) {
        if (val.length > 0) {
          this.motorcycleLocalDeliveries = [...val.filter(f => f.service_type === 'motorcycle')]
          this.carLocalDeliveries = [...val.filter(f => f.service_type === 'car')]
          if (this.motorcycleLocalDeliveries.length === 0) {
            this.localdeliveryService = 'car'
            this.showRadio = false
          } else if (this.carLocalDeliveries.length === 0) {
             this.localdeliveryService = 'motorcycle'
             this.showRadio = false
          }
        }
      }
    },
    selectedFulfilment: {
      deep: true,
      handler (val) {
        if (val) {
          this.localdeliveryService = val.service_type
        }
      }
    }
  },
  mounted () {
  },
}
</script>

<style scoped>
</style>

<i18n>
{
  "en": {
    "select_local_delivery": "Select delivery service",
    "motorcycle": "Motorcycle",
    "car": "Car"
  },
  "id": {
    "select_local_delivery": "Pilih layanan pengiriman",
    "motorcycle": "Sepeda motor",
    "car": "Mobil"
  }
}
</i18n>
